{
  "name": "anco-panel",
  "version": "0.1.13",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.15",
    "@angular/cdk": "^18.2.13",
    "@angular/common": "^19.2.15",
    "@angular/compiler": "^19.2.15",
    "@angular/core": "^19.2.15",
    "@angular/forms": "^19.2.15",
    "@angular/google-maps": "^18.2.14",
    "@angular/material": "^18.2.13",
    "@angular/material-moment-adapter": "^18.2.13",
    "@angular/platform-browser": "^19.2.15",
    "@angular/platform-browser-dynamic": "^19.2.15",
    "@angular/router": "^19.2.15",
    "@aws-amplify/ui-angular": "^5.1.6",
    "@popperjs/core": "^2.11.8",
    "aws-amplify": "^6.0.6",
    "geojson": "^0.5.0",
    "moment": "^2.30.1",
    "ngx-bootstrap": "^18.1.3",
    "ngx-bootstrap-icons": "^1.9.3",
    "ngx-editor": "^18.0.0",
    "ngx-spinner": "^18.0.0",
    "ngx-toastr": "^18.0.0",
    "rxjs": "^7.8.1",
    "tslib": "^2.7.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.19",
    "@angular/cli": "^19.2.19",
    "@angular/compiler-cli": "^19.2.15",
    "@types/jasmine": "^5.1.4",
    "@types/node": "^22.7.0",
    "bootstrap": "^5.3.3",
    "jasmine-core": "^5.4.0",
    "jquery": "^3.7.1",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "typescript": "~5.5.4"
  }
}
